import React, { useState, useContext, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { alpha, styled } from "@mui/material/styles";
import { Button, Input, TablePagination } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { LoginContext } from "../../../contexts/loginContext";
import createInstance from "../../../api/axiosinstance";
import Modal from "../Modal";
import Toast from "../../../utils/toast";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector } from "react-redux";
// import COLORS from "../../Themes/Colours";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

const DepartmentManagement = () => {
  // const { isLoggedIn, adminId: admin_id } = useContext(LoginContext);
  const [deptName, setDeptName] = useState("");
  const [creationDate] = useState(new Date().toISOString());
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [deptData, setDeptData] = useState([]);
  const [deptId, setDeptId] = useState();
  const [editingRowId, setEditingRowId] = useState(null);
  const [editedName, setEditedName] = useState("");
  const [deactivateId, setDeactiveId] = useState("");
  const [editedId, setEditedId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortingOrder, setSortingOrder] = useState("asc");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const { user } = useSelector((state) => state.auth);
  const admin_id = user?.user_id;
  const aiDishaApi = createInstance("DISHA");
  const { COLORS } = useThemeMode();

  useEffect(() => {
    fetchData();
    console.log("res", user);
  }, []);
  useEffect(() => {
  setPage(0);
}, [searchTerm]);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchData = async () => {
    try {
      const response = await aiDishaApi.get(`/all-departments/`);

      console.log("Fetched data from API:", response.data);

      if (response.data?.departments) {
        setDeptData(response.data.departments);
      } else {
        console.error("Unexpected response structure:", response.data);
      }
    } catch (error) {
      console.error(
        "Error fetching dept data:",
        error.response?.data?.message || error.message
      );
    }
  };
  useEffect(() => {
    if (deptName === "") {
      setPage(0); // Reset pagination to the first page
      setIsEdit(false); // Exit edit mode
    }
  }, [deptName]);

  const handleSort = (field) => {
    const sortedData = [...deptData].sort((a, b) => {
      if (sortingOrder === "asc") {
        return a[field].localeCompare(b[field]);
      } else {
        return b[field].localeCompare(a[field]);
      }
    });
    setDeptData(sortedData);
    setSortingOrder(sortingOrder === "asc" ? "desc" : "asc");
  };
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };
  // Filter department data based on search term
  const filteredDeptData = deptData.filter((dept) =>
    (dept.dept_name || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDeptSubmit = async () => {
    try {
      if (!deptName.trim()) {
        console.error("Department name cannot be empty");
        Toast.error("Department name cannot be empty");
        return;
      }
      const existingDept = deptData.find((dept) => dept.dept_name === deptName);
      if (existingDept) {
        console.error("Department name already exists");
        Toast.error("Department name already exists");
        return;
      }
      console.log("Submitting with admin_id:", admin_id, "deptName:", deptName);

      // Make the POST request with admin_id as a query parameter
      const response = await aiDishaApi.post(
        `/admin-departments/?admin_id=${admin_id}`,
        {
          dept_name: deptName,
          creation_date: creationDate,
          status: "Active",
        }
      );

      if (response.status === 200) {
        Toast.success("Dept added successfully");
        setDeptName("");
        fetchData();
      }
    } catch (error) {
      console.error("Error:", error.response?.data?.message || error.message);
      Toast.error(error.response?.data?.message || "Failed to add department");
    }
  };

  const handleEdit = (id, name) => {
    setDeptId(id);
    setEditedName(name);
    setDeptName(name);
    setIsEdit(true);
  };

  const handleDeptEdit = async (dept_id) => {
    try {
      const existingDept = deptData.find(
        (dept) => dept.dept_name === deptName && dept.dept_id !== dept_id
      );
      if (existingDept) {
        console.error("Department name already exists");
        Toast.error("Department name already exists");
        return;
      }

      // If the department name is unique, proceed with the update
      const updateResponse = await aiDishaApi.put(
        `/admin-departments-update?dept_id=${dept_id}&admin_id=${admin_id}`,
        {
          dept_name: deptName,
          updated_date: new Date().toISOString(),
        }
      );

      if (updateResponse.status === 200) {
        Toast.success("Department updated successfully");
        setDeptName("");
        fetchData();
        setIsEdit(false);
      }
      const updatedDeptData = deptData.map((dept) => {
        if (dept.dept_id === deptId) {
          return { ...dept, dept_name: deptName };
        } else {
          return dept;
        }
      });
      setDeptData(updatedDeptData);
      setIsEdit(false);
      setDeptName("");
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setEditingRowId(null);
    }
  };

  const handleClear = () => {
    setDeptName("");
    setDeptId("");
    setSearchTerm("");
  };

  const handleModalOpen = (dept_id, status) => {
    console.log("dept_id handlemodal check", dept_id);
    console.log("dept_id status handlemodal check", status);
    setDeactiveId(dept_id);
    setSelectedStatus(status);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleDeactivateDept = async (dept_id, currentStatus) => {
    console.log("dept_id status check", dept_id);
    console.log("dept_id status check", currentStatus);
    try {
      const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

      const response = await aiDishaApi.patch(
        `/admin-departments-status/?dept_id=${dept_id}&admin_id=${admin_id}&status_update=${newStatus}`
      );

      if (response.status === 200) {
        Toast.success("Department Status Updated successfully");
        fetchData();
      }
      if (response.status === 200) {
        const updatedDeptData = deptData?.filter(
          (dept) => dept.dept_id !== deactivateId
        );
        setDeptData(updatedDeptData);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const deptHeader = [
    {
      id: "Department ID",
      name: "Department Name",
      creationDate: "Creation Date",
      action: "Action",
    },
  ];

  const CssTextField = styled(TextField)({
    "& label": {
      color: "#FEFEFE",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "white",
        borderRadius: 10,
      },
      "&:hover fieldset": {
        borderColor: "white",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#B9B9B9",
      },
      "& .MuiInputBase-input": {
        color: "#FEFEFE",
      },
    },
  });

  return (
    <div>
      {isEdit ? (
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          sx={{
            marginTop: "30px",
            alignItems: "center",
            background: COLORS.primary, // Opacity set to 20%,
            borderRadius: "10px",
            padding: "15px",
          }}
        >
          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "20px" }}
          >
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "28px", color: COLORS.text }}
            >
              Edit Department
            </Typography>
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "16px", color: COLORS.text }}
            >
              Edit the name of the Department
            </Typography>
          </Box>

          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
          >
            <Paper
              sx={{
                p: "2px 4px",
                display: "flex",
                width: "75%",
                borderRadius: 2,
                background:  COLORS.background, // Set background color to black
              }}
            >
              <IconButton
                type="button"
                sx={{ p: "8px", color:  COLORS.text }}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
              <InputBase
                sx={{ ml: 1, flex: 1, fontFamily: "Poppins", color:  COLORS.text ,
                  "& input::placeholder": {
                             color: `${COLORS.text} !important`, // 👈 placeholder color
                             opacity: 10, // important (MUI reduces opacity by default)
                           },
                 }} // Set text color to white
                placeholder="Search by Department Name"
                inputProps={{ "aria-label": "search google maps" }}
                value={searchTerm}
                onChange={handleSearch}
              />
            </Paper>
          </Box>

          <Box
            gridColumn="span 5"
            sx={{ marginTop: "auto", textAlign: "left" }}
          >
            <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
              Department Name
            </Typography>
            <TextField
              size="small"
              id="custom-css-outlined-input"
              label="Dept Name"
              variant="outlined"
              value={deptName}
              onChange={(e) => setDeptName(e.target.value)}
              sx={{
                color:  COLORS.text,
                background: COLORS.background,
                borderRadius: 2,
                width: "95%",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "none",
                  borderRadius: "10px",
                },
                "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "none",
                  },
                "& .MuiInputLabel-root": {
                  color: COLORS.text,
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: COLORS.text, // Optional: Change label color when focused
                },
                "& .MuiInputBase-input": {
                  color: COLORS.text, // This sets the text color to white
                },
                "& .MuiOutlinedInput-root": {
                  color: COLORS.text, // This also helps with input text color
                },
              }}
              required
            />
          </Box>

          <Box
            gridColumn="span 3"
            sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}
          >
            <Button
              onClick={handleClear}
              sx={{
                border: "1px solid",
                color:  COLORS.button,
                "&:hover": {
                  color: COLORS.hover_btn,
                },
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
            >
              Clear
            </Button>
          </Box>

          <Box
            gridColumn="span 3"
            sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}
          >
            <Button
              sx={{
                background:  COLORS.button,
                "&:hover": {
                  background: COLORS.hover_btn,
                },
                // color: "white",
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
              onClick={() => handleDeptEdit(deptId)}
            >
              <Typography sx={{ fontFamily: "poppins", color: COLORS.background }}>
                Save
              </Typography>
            </Button>
          </Box>
        </Box>
      ) : (
        <Box
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          sx={{
            marginTop: "30px",
            alignItems: "center",
            // background: alpha("#033538", 1), // Opacity set to 20%,
            background: COLORS.primary, // Opacity set to 20%,
            borderRadius: "10px",
            padding: "15px",
          }}
        >
          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "20px" }}
          >
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "28px", color: COLORS.text }}
            >
              Add Department
            </Typography>
            <Typography
              sx={{ fontFamily: "poppins", fontSize: "16px", color: COLORS.text }}
            >
              Edit the name of the Department
            </Typography>
          </Box>

          <Box
            gridColumn="span 6"
            sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
          >
            <Paper
              sx={{
                p: "2px 4px",
                display: "flex",
                width: "75%",
                borderRadius: 2,
                color: "red",
                backgroundColor: COLORS.background, // Set background color to black
              }}
            >
              <IconButton
                type="button"
                sx={{ p: "8px", color: COLORS.text}}
                aria-label="search"
              >
                <SearchIcon />
              </IconButton>
              <InputBase
                sx={{ ml: 1, 
                  flex: 1, 
                  fontFamily: "Poppins", 
                  color: COLORS.text,
                  "& input::placeholder": {
                             color: `${COLORS.text} !important`, // 👈 placeholder color
                             opacity: 10, // important (MUI reduces opacity by default)
                           }, }} // Set text color to white
                placeholder="Search by Department Name"
                inputProps={{ "aria-label": "search google maps" }}
                value={searchTerm}
                onChange={handleSearch}
              />
            </Paper>
          </Box>

          <Box
            gridColumn="span 5"
            sx={{ marginTop: "auto", textAlign: "left" }}
          >
            <Typography sx={{ fontFamily: "poppins", color: COLORS.text }}>
              Department Name
            </Typography>
            <TextField
              size="small"
              id="outlined-input"
              label="Dept Name"
              variant="outlined"
              value={deptName}
              onChange={(e) => setDeptName(e.target.value)}
              sx={{
                background: COLORS.background,
                // borderRadius: 2,
                width: "95%",
                // "& .MuiOutlinedInput-notchedOutline": {
                //   borderColor: COLORS.border,
                //   borderRadius: "10px",
                // },
                // "&.MuiOutlinedInput-root.Mui-focused.MuiOutlinedInput-notchedOutline":
                //   {
                //     borderColor: COLORS.border,
                //   },
                
                "& .MuiInputLabel-root": {
                  color: COLORS.text,
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: COLORS.text, // Optional: Change label color when focused
                },
                "& .MuiInputBase-input": {
                  color: COLORS.text, // This sets the text color to white
                },
                "& .MuiOutlinedInput-root": {
                  color: COLORS.text, // This also helps with input text color
                },
              }}
              required
            />
          </Box>

          <Box
            gridColumn="span 3"
            sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}
          >
            <Button
              onClick={handleClear}
              sx={{
                border: "1px solid",
                color: COLORS.button,
                "&:hover": {
                  color: COLORS.hover_btn,
                },
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
            >
              Clear
            </Button>
          </Box>

          <Box
            gridColumn="span 3"
            sx={{ marginTop: "auto", textAlign: "left", marginLeft: 10 }}
          >
            <Button
              sx={{
                background: COLORS.button,
                color: COLORS.background,
                "&:hover": {
                  background: COLORS.hover_btn,
                },
                width: "150px",
                height: "40px",
                borderRadius: "10px",
                fontFamily: "poppins",
              }}
              onClick={handleDeptSubmit}
            >
              <Typography sx={{ fontFamily: "poppins", 
                color: COLORS.background ,
                 }}>
                Save
              </Typography>
            </Button>
          </Box>
        </Box>
      )}

      <Box xs={1} sx={{ backgroundColor: "#33333" }}>
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={10}>
            <TableContainer
              component={Paper}
              sx={{
                marginTop: "25px",
                borderRadius: "10px",
              }}
            >
              <Table size="small">
                <TableHead sx={{ background: COLORS.primary }}>
                  {deptHeader.map(({ id, name, creationDate, action }) => (
                    <React.Fragment key={id}>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {id}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          borderBottom: 0,
                          cursor: "pointer",
                        }}
                        onClick={() => handleSort("dept_name")}
                      >
                        {name} {sortingOrder === "asc" ? "↑" : "↓"}
                      </TableCell>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {creationDate}
                      </TableCell>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {action}
                      </TableCell>
                    </React.Fragment>
                  ))}
                </TableHead>
                <TableBody>
                  {filteredDeptData &&
                    filteredDeptData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((n, index) => (
                        <TableRow
                          key={n.dept_id}
                          sx={{
                            background: COLORS.background,
                            marginRight: "30px",
                          }}
                        >
                          <TableCell
                            sx={{ color: COLORS.text, borderColor: COLORS.secondary  }}
                          >
                            {n.dept_id}
                          </TableCell>
                          <TableCell
                            sx={{ color: COLORS.text, borderColor: COLORS.secondary }}
                          >
                            {editingRowId === n.dept_id ? (
                              <Input
                                value={editedName}
                                onChange={(e) => setEditedName(e.target.value)}
                              />
                            ) : (
                              n.dept_name
                            )}
                          </TableCell>
                          <TableCell
                            sx={{ color: COLORS.text, borderColor: COLORS.secondary }}
                          >
                            {new Date(n.creation_date).toLocaleDateString(
                              "en-GB"
                            )}
                          </TableCell>
                          <TableCell
                            sx={{
                              borderBottom: COLORS.secondary,
                              borderRight: COLORS.secondary,
                              display: "flex",
                              alignItems: "center",
                              fontFamily: "poppins",
                            }}
                          >
                            {editingRowId === n.dept_id ? (
                              <Button
                                variant="contained"
                                sx={{
                                  background: COLORS.button_edit_bg,
                                  "&:hover": {
                                    background: COLORS.hover_edit_btn,
                                  },
                                  color: COLORS.background,
                                  marginRight: "10px",
                                  fontFamily: "poppins",
                                  height: "20px",
                                  width: "30px",
                                }}
                              >
                                Save
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                onClick={() =>
                                  handleEdit(n.dept_id, n.dept_name)
                                }
                                sx={{
                                  background: COLORS.button_edit_bg,
                                  "&:hover": {
                                    background: COLORS.hover_edit_btn,
                                  },
                                  color: COLORS.background,
                                  marginRight: "10px",
                                  fontFamily: "poppins",
                                  height: "20px",
                                  width: "30px",
                                }}
                              >
                                Edit
                              </Button>
                            )}
                            <Button
                              variant="contained"
                              sx={{
                                background:
                                  n.status === "Active" ? COLORS.button_red_bg : COLORS.button_green_bg,
                                // color: "#ffffff",
                                color: COLORS.text,
                                fontFamily: "poppins",
                                height: "24px",
                                padding: "2px 8px",
                                minWidth: "90px",
                                fontSize: "0.75rem",
                                  "&:hover": {
                                    background:
                                      n.status === "Active"
                                        ? COLORS.hover_red_btn      // hover when Active (Deactivate button)
                                        : COLORS.hover_green_btn,   // hover when Inactive (Activate button)
                                  },
                              }}
                              onClick={() => {
                                console.log(
                                  "Deactivate button clicked for:",
                                  n.dept_id,
                                  n.status
                                );
                                handleModalOpen(n.dept_id, n.status);
                              }}
                            >
                              {/* Deactivate */}
                              {n.status === "Active"
                                ? "Deactivate"
                                : "Activate"}
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15]}
                component="div"
                count={filteredDeptData ? filteredDeptData.length : 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  background: COLORS.primary,
                  color: COLORS.text, 
                }}
              />
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        title="Department"
        action={() => handleDeactivateDept(deactivateId, selectedStatus)}
        actionType={selectedStatus === "Active" ? "Deactivate" : "Activate"}
      />
    </div>
  );
};

export default DepartmentManagement;
